/**
 * Registry for Spill the Tea modal: post type selector metadata (labels, icons, styles).
 * Thread is comment-backed; other entries are post-backed `EntityKind` values.
 */
import { OctagonAlert, Speech, Blocks, HandFist, ListTree, Group, type LucideIcon } from "lucide-react";
import type { EntityKind } from "util/posts";

/** Modal-only create types (includes thread, which is not a post `kind`). */
export type SpillPostType = "thread" | EntityKind;

export interface SpillKindRow {
  key: SpillPostType;
  label: string;
  Icon: LucideIcon;
  /** Tailwind classes when selected */
  activeClass: string;
}

export const SPILL_KIND_ROWS: SpillKindRow[] = [
  {
    key: "thread",
    label: "Thread",
    Icon: ListTree,
    activeClass: "bg-soc-purple text-white font-semibold",
  },
  {
    key: "impact",
    label: "Impact",
    Icon: OctagonAlert,
    activeClass: "bg-yellow-500 text-white font-semibold",
  },
  {
    key: "teabate",
    label: "Teabate",
    Icon: Speech,
    activeClass: "bg-eoe-entity-teabate text-white font-semibold",
  },
  {
    key: "solution",
    label: "Solution",
    Icon: Blocks,
    activeClass: "bg-eoe-entity-solution text-white font-semibold",
  },
  {
    key: "action",
    label: "Action",
    Icon: HandFist,
    activeClass: "bg-eoe-entity-action text-white font-semibold",
  },
  {
    key: "collection",
    label: "Collection",
    Icon: Group,
    activeClass: "bg-sky-600 text-white font-semibold",
  },
];
